__webpack_require__.p = "https://products.earthobservatory.sg/";